<template>
	<div class="com-list-content">
		<com-search :model="search" :transfer-model.sync="condition" v-slot="{data}" :table="$refs.table">
			<ui-text v-model="data.title" label="诗名"/>
			<ui-select v-model="data.gradeId" label="年级" url="/admin/grade/list?page=1&limit=100" value-field="id" text-field="name"/>
			<ui-template>
				<ui-button type="search"></ui-button>
				<ui-button type="add" @click="add">增加</ui-button>
			</ui-template>
		</com-search>
		<com-table ref="table" url="/admin/poetry/list" :search="condition" v-slot="{data}">
			<ui-text v-model="data.title" label="诗名"/>
			<ui-text v-model="data.author" label="作者"/>
			<ui-select v-model="data.gradeId" label="年级" url="/admin/grade/list?page=1&limit=100" value-field="id" text-field="name"/>
			<ui-text v-model="data.click" label="阅读量"/>
			<ui-text v-model="data.createTime" label="创建时间"/>
			<ui-template label="操作">
				<ui-button type="edit" @click="edit(data)"/>
				<ui-button type="delete" @click="remove(data)"/>
			</ui-template>
		</com-table>
	</div>
</template>

<script>
export default {
	data(){
		return {
			search:{},
			condition:{},
		};
	},
	mounted(){
	},
	methods:{
		add(){
			this.$dialog('poetry_detail',{type:'add',data:{}},()=>{
				this.$refs.table.refresh();
			})
		},
		edit(data){
			this.$dialog('poetry_detail',{type:'edit',data:data},()=>{
				this.$refs.table.refresh();
			})
		},
		remove(data){
			this.$axios.delete('/admin/poetry/option/'+data.id)
			.then(data=>{
				this.$refs.table.refresh();
			}).end();
		}
	}
}
</script>

<style>
</style>
